export default {
    getAzureAdConfigurations: { method: 'get', url: 'integrations/azure-ad-configurations' },
    postAzureAdConfigurations: { method: 'post', url: 'integrations/azure-ad-configurations' },
    putAzureAdConfigurations: { method: 'put', url: 'integrations/azure-ad-configurations/{id}' },
    deleteAzureAdConfigurations: { method: 'delete', url: 'integrations/azure-ad-configurations/{id}' },
}
